import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//

import Icon from "@Shared/components/general/fa-icon";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FixedBanner",
  components: {
    Icon
  },
  props: {
    icon: {
      type: [String, Boolean],
      default: ""
    },
    type: {
      type: String,
      default: "info",
      validator(value) {
        const validActions = ["info", "error", "success", "warning", "notice"];
        return _includesInstanceProperty(validActions).call(validActions, value);
      }
    },
    positionFixed: {
      type: Boolean,
      default: true
    },
    sideRight: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    typeClass() {
      const fixedTop = this.positionFixed ? "fixed-top" : "";
      const sideRight = this.sideRight ? "side-right" : "";
      const typeParser = {
        info: "bg-primary",
        success: "bg-success",
        error: "bg-danger",
        warning: "bg-warning",
        notice: "bg-light-gray"
      };
      return `${typeParser[this.type]} ${fixedTop} ${sideRight}`;
    },
    iconToUse() {
      const iconParser = {
        info: "info-circle",
        success: "check",
        error: "times",
        warning: "exclamation-circle"
      };
      return this.icon || iconParser[this.type];
    }
  }
});